import dayjs from "dayjs";

/**
 * Quick-select date range presets for antd DatePicker.RangePicker.
 * Pass as: <DatePicker.RangePicker presets={DATE_PRESETS} />
 */
export const DATE_PRESETS = [
    { label: "Hôm nay", value: [dayjs().startOf("day"), dayjs().endOf("day")] },
    {
        label: "Hôm qua",
        value: [dayjs().subtract(1, "day").startOf("day"), dayjs().subtract(1, "day").endOf("day")],
    },
    { label: "7 ngày qua", value: [dayjs().subtract(6, "day").startOf("day"), dayjs().endOf("day")] },
    { label: "30 ngày qua", value: [dayjs().subtract(29, "day").startOf("day"), dayjs().endOf("day")] },
    { label: "Tháng này", value: [dayjs().startOf("month"), dayjs().endOf("month")] },
    {
        label: "Tháng trước",
        value: [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")],
    },
];
